import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import SEO from "@/components/SEO";

const DietarySlider = lazy(() => import("@/components/DietarySlider"));
const AboutSection = lazy(() => import("@/components/AboutSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const Footer = lazy(() => import("@/components/Footer"));

const HOME_TITLE = "PastaLuna | פסטה איטלקית ללא גלוטן, טבעונית ועשירה בחלבון";
const HOME_DESCRIPTION = "פסטה לונה (PastaLuna) פסטה איטלקית איכותית ללא גלוטן, 100% טבעונית ועשירה בחלבון. חוויה קולינרית בריאה ומזינה בכל ביס. היכנסו לאתר למגוון המוצרים.";

const Index = () => {
  return (
    <div id="top" dir="rtl" className="min-h-screen bg-background">
      <SEO
        title={HOME_TITLE}
        description={HOME_DESCRIPTION}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://pastaluna.co.il/#organization",
            name: "PastaLuna",
            url: "https://pastaluna.co.il",
            logo: "https://pastaluna.co.il/favicon-192.png",
            email: "pastalunadelivery@gmail.com",
            description: HOME_DESCRIPTION,
            sameAs: [],
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "@id": "https://pastaluna.co.il/#website",
            name: "PastaLuna",
            url: "https://pastaluna.co.il",
            inLanguage: "he-IL",
            publisher: { "@id": "https://pastaluna.co.il/#organization" },
            description: HOME_DESCRIPTION,
          },
        ]}
      />
      <Header />
      <main id="main">
        <h1 className="sr-only">PastaLuna - פסטה איטלקית פרימיום ללא גלוטן, טבעונית ועשירה בחלבון</h1>
        <HeroSection />
        <Suspense fallback={null}>
          <DietarySlider />
          <AboutSection />
          <ContactSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
